<div class="wrapper" *ngIf="Token" [class.sidebar-collapsed]="!isMobileViewport && sidebarCollapsed" [class.sidebar-mobile-open]="isMobileViewport && mobileSidebarOpen">


  <!--=================================
   preloader -->

  <div id="pre-loader">
    <img src="assets/Content/images/pre-loader/loader-01.svg" alt="">
  </div>

  <!--=================================
   preloader -->


  <!--=================================
   header start-->

  <nav class="admin-header header-dark navbar navbar-default col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
    <!-- Top bar left -->
    <ul class="nav navbar-nav mr-auto">
      <li class="nav-item">
        <button id="button-toggle" type="button" class="button-toggle-nav inline-block ml-20 pull-left sidebar-toggle"
          (click)="toggleSidebar($event)" [attr.aria-expanded]="isMobileViewport ? mobileSidebarOpen : !sidebarCollapsed"
          aria-controls="right-sidebar" [attr.aria-label]="isMobileViewport ? (mobileSidebarOpen ? 'بستن منو' : 'باز کردن منو') : (sidebarCollapsed ? 'باز کردن منو' : 'جمع کردن منو')">
          <i class="zmdi zmdi-menu ti-align-right" aria-hidden="true"></i>
        </button>
      </li>
      <li class="nav-item">
        <div class="search">
          <a style="font-family: Arial, Helvetica, sans-serif;" class="button-toggle-nav inline-block ml-20 pull-left"
            href="#">Version 7.15.0</a>
        </div>
      </li>
      <li class="nav-item">
        <div class="search">
          <a  class="button-toggle-nav inline-block ml-20 pull-left"
            href="#">13 - 08 - 1405</a>
        </div>
      </li>
      <li class="nav-item" *ngIf="onlineUser.length>0">
        <div class="search">
          <a *ngIf="Type==1" (click)="OnShow_onlineUser(template_OnlineUser)" class="button-toggle-nav inline-block ml-20 pull-left" >{{onlineUser.length}} کاربر برخط </a>
          <a *ngIf="Type!=1" class="button-toggle-nav inline-block ml-20 pull-left" href="#">{{onlineUser.length}} کاربر برخط </a>


        </div>
      </li>
      <li class="nav-item" *ngIf="Type==1 || Type==2">
        <div class="search">
          <a  class="button-toggle-nav inline-block ml-20 pull-left" href="#">ماه {{UserUrl_Min_Month}}</a>
          <a  class="button-toggle-nav inline-block ml-20 pull-left" href="#">دیروز {{UserUrl_Min_YesterDay}}</a>


        </div>
      </li>
    </ul>
    <!-- top bar right -->
    <ul class="nav navbar-nav ml-auto">
      <li class="nav-item">
        <a class="nav-link top-nav">{{nowDate}} ساعت {{nowClock| date:'HH:mm:ss'}}</a>
      </li>


      <li *ngIf="!Comment_Proccessing  && Comment_Show_Button" class="nav-item shakeit" style="cursor: pointer;" (click)="OnShowComment(templateComment)">
        <a class="nav-link top-nav" title="نظرات"><i class="fa fa-commenting"></i></a>
        <div class="shakeitText">
          <div class="shakeitTextFirst"></div>
          <div class="shakeitTextSecond">نظرات را مشاهده نمائید</div>
        </div>
      </li>
      <li *ngIf="Comment_Show_Button"  class="nav-item" style="cursor: pointer;">
        <a class="nav-link top-nav" routerLink="/CustomerListUser" title="مشتریان"><i class="fa fa-vcard"></i></a>
      </li>

      <li *ngIf="DevicePersianEngHelp_Show_Button" class="nav-item shakeit" style="cursor: pointer;" (click)="OnShow_DevicePersianEngHelp(template_DevicePersianEngHelp)">
        <a class="nav-link top-nav" title="جستجوی دستگاه ها"><i class="fa fa-cc-amex"></i></a>
        <div class="shakeitText">
          <div class="shakeitTextFirst"></div>
          <div class="shakeitTextSecond">جستجوی دستگاه ها</div>
        </div>
      </li>
      <li *ngIf="Comment_Proccessing" class="nav-item" style="cursor: pointer;" >
        <a class="nav-link top-nav" title="نظرات"><i class="fa fa-spin fa-refresh"></i></a>
      </li>



      <li *ngIf="!Help_Proccessing" class="nav-item" style="cursor: pointer;" (click)="OnShowHelp(templateHelp)">
        <a class="nav-link top-nav" title="راهنما"><i class="fa fa-question-circle-o"></i></a>
      </li>
      <li *ngIf="Help_Proccessing" class="nav-item" style="cursor: pointer;" >
        <a class="nav-link top-nav" title="راهنما"><i class="fa fa-spin fa-refresh"></i></a>
      </li>



      <li class="nav-item dropdown " *ngIf="DataList_Alert.length>0" style="cursor: pointer;" (click)="Show_All_Alerm()">
        <a class="nav-link top-nav">
          <i class="ti-bell"></i>
        </a>
      </li>
      <li class="nav-item fullscreen">
        <a id="btnFullscreen" style="cursor:pointer ;" class="nav-link"><i class="ti-fullscreen"></i></a>
      </li>
      <li class="nav-item dropdown " style="cursor: pointer;" (click)="openModalPassword(templatePassword)">
        <a class="nav-link top-nav"><i class="fa fa-key"></i></a>
      </li>
      <li class="nav-item dropdown mr-30">
        <a class="nav-link nav-pill user-avatar" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
          aria-expanded="false">
          <img src="{{BaserUrlImage}}" alt="avatar">
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <div class="dropdown-header">
            <div class="media">
              <div class="media-body">
                <h5 class="mt-0 mb-0">{{Fullname}}</h5>
                <span *ngIf="this.Type=='1'">کاربر ارشد</span>
                <span *ngIf="this.Type=='2'">کاربر عادی</span>
                <span *ngIf="this.Type=='3'">کاربر مشتری</span>
                <span *ngIf="this.Type=='4'">کاربر نماینده مشتری</span>
              </div>
            </div>
          </div>
          <div class="dropdown-divider"></div>
          <a (click)="OnExit()" class="dropdown-item" href="#"><i class="text-danger ti-unlock"></i>خروج</a>
        </div>
      </li>

    </ul>
  </nav>

  <!--=================================
   header End-->

  <!--=================================
   Main content -->

  <div class="container-fluid">
    <div class="row">
      <!-- Right sidebar -->
      <button *ngIf="isMobileViewport && mobileSidebarOpen" type="button" class="sidebar-backdrop" aria-label="بستن منو" (click)="toggleSidebar()"></button>
      <div class="side-menu-fixed" id="right-sidebar" role="navigation" aria-label="منوی اصلی"
        [attr.aria-hidden]="isMobileViewport && !mobileSidebarOpen ? 'true' : null"
        [attr.inert]="isMobileViewport && !mobileSidebarOpen ? '' : null">
        <div class="sidebar-brand">
          <img src="assets/Content/icon.png" alt="" class="sidebar-brand-icon">
          <div class="sidebar-brand-copy">
            <strong>بهینه فرآیند آزما</strong>
            <small>سامانه مدیریت</small>
          </div>
        </div>
        <div class="sidebar-menu-scroll">
          <app-Nav [collapsed]="!isMobileViewport && sidebarCollapsed" (expandRequested)="expandSidebarFromMenu()"></app-Nav>
        </div>

      </div>
      <!-- Right sidebar end -->

      <!--=================================
   Main content -->

      <!--=================================
  wrapper -->

      <div class="content-wrapper">
        <router-outlet></router-outlet>
        <div style="margin-top: 50px;">
          <a style="font-family: Arial, Helvetica, sans-serif;float:left ;" href="https://moeinattari.ir/"> &copy; Developed in 2022
          </a>

        </div>
        <div style="clear: both;">

        </div>
      </div>
    </div>
  </div>

  <div id="OnlineUser" style="display: none;">
    <p> {{onlineUser}} نفر آنلاین <i class="fa fa-user"></i></p>
  </div>

</div>

<div class="wrapper" *ngIf="!Token">
  <app-Login></app-Login>
</div>




<ng-template #templatePassword>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> تغییر رمز عبور </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ResetPassword.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> رمز عبور فعلی </label>
          <input type="password" class="form-control" [(ngModel)]="CurrentPassword" placeholder=" اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> رمز عبور جدید </label>
          <input type="password" class="form-control" [(ngModel)]="NewPassword" placeholder=" اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> تکرار رمز عبور جدید </label>
          <input type="password" class="form-control" [(ngModel)]="NewRePassword" placeholder=" اینجا تایپ کنید ...">
        </div>
      </div>

    </div>

  </div>
  <div class="modal-footer">
    <img *ngIf="ProccesingPassword" src="assets/Loading.gif" style="width: 25px;" />
    <button type="button" *ngIf="!ProccesingPassword" (click)="ResetPassword()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-pencil"></i> ثبت اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_ResetPassword.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateHelp>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> {{Help_Nav_Title}} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Help.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <app-HelpView [DataList_Behfa]="Select_Record_Help"></app-HelpView>
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Help.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateComment>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> {{Comment_Nav_Title}} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Comment.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>توضیحات</th>
              <th>درجه اهمیت</th>
              <th>ثبت کننده</th>
              <th>تاریخ ثبت</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Select_Record_Comment" >
             <td>{{Select_Record_Comment.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>

              <th>
                <p *ngIf="item.code=='0'" style="color: #489b39;">عادی</p>
                <p *ngIf="item.code=='1'" style="color: #9b7439;">مهم</p>
                <p *ngIf="item.code=='2'" style="color: #9b394e;">حیاتی</p>

              </th>

              <td>{{item.username}}</td>
              <td>{{item.persianDate}} </td>
            </tr>
          </tbody>
        </table>
     </div>

     <br />
     <hr />
     <br />


     <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">{{Comment_Nav_Form_Title}}</label>
        <textarea type="text" class="form-control" [(ngModel)]="Comment_Nav_Form_Dsc" placeholder="اینجا تایپ کنید ...">
        </textarea>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <button type="button" *ngIf="!InProccessing" class="btn btn-success" (click)="Submit_Comment()">
          ارسال و ثبت نظر </button>
      </div>
    </div>

     <hr/>

    </div>

  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Comment.hide()">متوجه شدم</button>
  </div>
</ng-template>


<div class="TokenStation" *ngIf="Token && Token_Station_Remain<=60">
  <div class="TokenStationCenter">
      <h4>مدت اعتبار احراز هویت شما <span style="color:red ;">{{Token_Station_Remain}}</span> ثانیه دیگر تمام می شود.</h4>
      <br/>
      <button *ngIf="!Token_Station_Proccessing" type="button" class="btn btn-success" (click)="ExtensionTokenStation()"><i class="fa fa-clock-o"></i> تمدید احراز هویت</button>
      <button *ngIf="Token_Station_Proccessing" type="button" class="btn btn-success" ><i class="fa fa-spin fa-refresh"></i> لطفا صبر نمائید ... </button>
      <button type="button" style="margin-right:10px ;" (click)="OnExit()" class="btn btn-danger"><i class="fa fa-power-off"></i> خروج از سیستم </button>
  </div>
</div>

<ng-container *ngFor="let item of DataList_Alert">

  <div class="TokenStation" *ngIf="!item.del">
    <div class="TokenStationRight">
        <h4> اطلاعیه - {{item.title}}</h4>
        <br/>
        <div  class="acd-des" innerHTML="{{item.message}}"></div>

        <br/>
        <ul>
            <li *ngFor="let file of item.files">
              <a target="_blank" href="{{BaseUrl}}File/Alert/{{file}}"  ><i class="fa fa-download"></i>
                 فایل پیوست شده شماره {{item.files.indexOf(file)+1}}
              </a>
            </li>
        </ul>
        <br/>

        <button type="button" (click)="See_Alert(item)" class="btn btn-danger"><i class="fa fa-eye-slash"></i> مشاهده شد </button>
    </div>
  </div>

</ng-container>

<ng-template #template_DevicePersianEngHelp>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> راهنمای جستجوی دستگاه </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DevicePersianEngHelp.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> کلید واژه</label>
          <input type="text" class="form-control" name="key_DevicePersianEngHelp"
            [(ngModel)]="key_DevicePersianEngHelp" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام انگلیسی</th>
              <th>نام فارسی</th>
              <th>کمیت</th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Select_Record_DevicePersianEngHelp">
              <td>{{Select_Record_DevicePersianEngHelp.indexOf(item)+1}}</td>
              <td>{{item['device_name']}}</td>
              <td>{{item['dsc']}}</td>
              <td>{{item['quantity_title']}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="DevicePersianEngHelp_Proccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!DevicePersianEngHelp_Proccessing" type="button" (click)="Read_DevicePersianEngHelp()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_DevicePersianEngHelp.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #template_OnlineUser>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> کاربران آنلاین </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_onlineUser.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>عنوان کاربری</th>
              <th>نام کاربری</th>
              <th>نوع کاربری</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of onlineUser">
              <td>{{onlineUser.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <td>{{item.username}}</td>
              <td>{{item.type}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_onlineUser.hide()">بستن</button>
  </div>
</ng-template>
